import { InputAdornment, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useDispatch } from 'react-redux';
import { Tooltip } from '@material-ui/core';

import MailModal from '../../../components/layouts/layout1/mailModal';
import { get } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { setPage } from '../../../store/features/moments/momentsSlice';
import EmployeeCard from './employeeCard';
import ModalCreateActions from '../create-actions/modalCreateActions';

const MyTeams = (props: any) => {
    const dispatch = useDispatch();
    const { page, aside } = useAppSelector(state => state.moments);
    const { userInfo } = useAppSelector(state => state.users.info);
    const { words } = useAppSelector(state => state.localization);
    const [mailShowModal, setMailShowModal] = useState<boolean>(false);
    const [openSuccessMessage, setOpenSuccessMessage] = useState<boolean>(false)

    const [searchParam, setSearchParam] = useState('');
    const [pageTitle, setPageTitle] = useState('');
    const [managerName, setManagerName] = useState('');
    const [position, setPosition] = useState('');
    const [employeeCount, setEmployeeCount] = useState(0);
    const [unfilteredEmployees, setUnfilteredEmployees] = useState([]);
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        if (page.type === 'departmants') {
            const department = aside?.departments?.filter(x => x?.showMenu)[page?.index];
            setPageTitle(department?.departmantName);
            setManagerName(department?.departmantManagerName);
            setPosition(department?.departmantManagerPosition);
            setEmployeeCount(department?.employeeCount);
            setEmployees(department?.employees);
            setUnfilteredEmployees(department?.employees);
            setSearchParam('');
        } else if (page.type === 'allEmployees') {
            const allEmployee = aside.allEmployees;

            if (userInfo) {
                setManagerName(userInfo.name + ' ' + userInfo.surname);
                setPosition(userInfo.position);
                setPageTitle(userInfo.departmentName);
            }
            setSearchParam('');
            setEmployeeCount(allEmployee.length);
            setEmployees(allEmployee);
            setUnfilteredEmployees(allEmployee);
        } else if (page.type === 'myTeams') {
            const userTeam = aside.userTeams;

            if (userInfo) {
                setPageTitle(userInfo.departmentName);
                setManagerName(userInfo.name + ' ' + userInfo.surname);
                setPosition(userInfo.position);
            }
            setSearchParam('');
            setEmployeeCount(userTeam.length);
            setEmployees(userTeam);
            setUnfilteredEmployees(userTeam);
        }
    }, [page, page.type]);

    const filterEmployees = () => {
        setEmployees(
            unfilteredEmployees.filter(
                x =>
                    x.name.toLocaleLowerCase().includes(searchParam.toLocaleLowerCase()) ||
                    x.surname.toLocaleLowerCase().includes(searchParam.toLocaleLowerCase()) ||
                    (x.name + ' ' + x.surname).toLocaleLowerCase().includes(searchParam.toLocaleLowerCase()),
            ),
        );
    };

    const filterEmployeesOnKeyUp = e => {
        if (e.key === 'Enter') {
            setEmployees(
                unfilteredEmployees.filter(
                    x =>
                        x.name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()) ||
                        x.surname.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()) ||
                        (x.name + ' ' + x.surname).toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()),
                ),
            );
        }
    };

    const onClickSendMail = async () => {
        await get<any>('users/send-team-fullness-ratio-mail');
        setMailShowModal(false);
        setTimeout(() => {
            setOpenSuccessMessage(true);
        }, 700);
    };

    const clearInputValue = () => {
        setSearchParam('');
        if (page.type === 'departmants') {
            const department: any = aside.departments.find(x => x.departmentId === page.id && x.employees && x.employees.length > 0);
            setEmployees(department.employees);
            setUnfilteredEmployees(department.employees);
        } else if (page.type === 'allEmployees') {
            const allEmployee = aside.allEmployees;

            setEmployees(allEmployee);
            setUnfilteredEmployees(allEmployee);
        } else if (page.type === 'myTeams') {
            const userTeam = aside.userTeams;
            setEmployees(userTeam);
            setUnfilteredEmployees(userTeam);
        }
    };


    return (
        <div className="my-teams-page">
            <div className="micro-content-01">
                <a href="#!" className="c-item-01" onClick={() => dispatch(setPage({ name: 'momentsHome', type: '', id: '' }))}>
                    <svg className="close-icon" width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="54" height="54" rx="27" fill="white" />
                        <path
                            d="M27.5003 42.0834C35.5545 42.0834 42.0837 35.5542 42.0837 27.5001C42.0837 19.4459 35.5545 12.9167 27.5003 12.9167C19.4462 12.9167 12.917 19.4459 12.917 27.5001C12.917 35.5542 19.4462 42.0834 27.5003 42.0834Z"
                            stroke="#6C6C7D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M31.875 23.125L23.125 31.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M23.125 23.125L31.875 31.875" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <rect x="0.5" y="0.5" width="54" height="54" rx="27" stroke="#F0F0F2" />
                    </svg>
                </a>

                {(page.type === 'departmants' || page.type === 'myTeams') && <h2 className="c-item-02">{pageTitle}</h2>}

                <div className='c-item-04'>
                    <div className="c-item-04-A">
                        {page.type !== 'myTeams' && (
                            <div className='c-item-04-A-01'>
                                <div className='c-item-04-A-01-A'>
                                    <svg className="c-unit-01" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1098_13005)">
                                            <path
                                                d="M13.333 17.5V15.8333C13.333 14.9493 12.9818 14.1014 12.3567 13.4763C11.7316 12.8512 10.8837 12.5 9.99967 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.08333 9.16667C8.92428 9.16667 10.4167 7.67428 10.4167 5.83333C10.4167 3.99238 8.92428 2.5 7.08333 2.5C5.24238 2.5 3.75 3.99238 3.75 5.83333C3.75 7.67428 5.24238 9.16667 7.08333 9.16667Z"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M14.167 9.16667L15.8337 10.8333L19.167 7.5"
                                                stroke="#00A3FF"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1098_13005">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="c-unit-02">{words && words['WEB.manager']}: </span>
                                </div>
                                {(page.type === 'departmants' || page.type === 'allEmployees') && (
                                    <div className='c-item-04-A-01-B'>
                                        <span className="c-unit-03">
                                            {managerName} /  {position}
                                        </span>
                                        <span className="c-unit-03">
                                            {pageTitle}
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                        <div>
                            <svg className="c-unit-01" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1098_13012)">
                                    <path
                                        d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.50033 9.16667C9.34127 9.16667 10.8337 7.67428 10.8337 5.83333C10.8337 3.99238 9.34127 2.5 7.50033 2.5C5.65938 2.5 4.16699 3.99238 4.16699 5.83333C4.16699 7.67428 5.65938 9.16667 7.50033 9.16667Z"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M19.167 17.5001V15.8334C19.1664 15.0948 18.9206 14.3774 18.4681 13.7937C18.0156 13.2099 17.3821 12.793 16.667 12.6084"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M13.333 2.6084C14.05 2.79198 14.6855 3.20898 15.1394 3.79366C15.5932 4.37833 15.8395 5.09742 15.8395 5.83757C15.8395 6.57771 15.5932 7.2968 15.1394 7.88147C14.6855 8.46615 14.05 8.88315 13.333 9.06673"
                                        stroke="#00A3FF"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1098_13012">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="c-unit-02">{words && words['WEB.managerTeam']} : </span>
                            <span className="c-unit-03">
                                {' '}
                                {employeeCount} {words && words['WEB.person']}
                            </span>
                        </div>

                        {page.type === 'myTeams' && (
                            <>
                                <span className="c-unit-04">{words && words['WEB.profileFullness']}</span>
                                <div className="circular-progressbar">
                                    <CircularProgressbar value={aside?.teamsAvarage} text={`%${aside?.teamsAvarage}`} />
                                </div>
                            </>
                        )}
                    </div>
                    {page.type === 'myTeams' && (
                        <div className="c-item-04-B">
                            <Tooltip
                                placement="top"
                                arrow
                                title="Ekip arkadaşlarının profilini doldurması için link gönderin."
                                className="c-item-02-B">

                                <button type='button' onClick={() => setMailShowModal(true)} className="c-unit-01">
                                    {words && words['WEB.getInformation']}
                                </button>
                            </Tooltip>
                        </div>
                    )}
                </div>
                <MailModal
                    message="Ekip arkadaşlarına bilgilerini paylaşması için mail ileteceğiz. Onaylıyor musunuz?"
                    open={mailShowModal}
                    setOpen={setMailShowModal}
                    onClickSendMail={onClickSendMail}
                />
            </div>

            <div className="micro-content-02">
                <TextField
                    onKeyUp={filterEmployeesOnKeyUp}
                    className="c-item-01"
                    id="inputWith-icon-textfield"
                    placeholder={words && words['WEB.searchTeamsIn']}
                    variant="standard"
                    value={searchParam}
                    onChange={e => setSearchParam(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <svg
                                    className="c-item-01-A"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M21.0004 20.9999L16.6504 16.6499"
                                        stroke="#7E7E92"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="start">
                                {searchParam && (
                                    <svg
                                        onClick={clearInputValue}
                                        className="c-item-01-B"
                                        width="35"
                                        height="35"
                                        viewBox="0 0 35 35"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17.4998 32.0832C25.554 32.0832 32.0832 25.554 32.0832 17.4998C32.0832 9.44568 25.554 2.9165 17.4998 2.9165C9.44568 2.9165 2.9165 9.44568 2.9165 17.4998C2.9165 25.554 9.44568 32.0832 17.4998 32.0832Z"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M21.875 13.125L13.125 21.875"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M13.125 13.125L21.875 21.875"
                                            stroke="#6C6C7D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />

                <a href="#!" onClick={filterEmployees} className="c-item-02">
                    <p className="c-item-02-A">{words && words['WEB.search']}</p>
                </a>
            </div>
            {(!employees || employees.length === 0) && <div className="not-found">{words && words['WEB.noPersonFounded']}</div>}

            <div className="my-teams-list">{employees && employees?.map(employee => <EmployeeCard employee={employee} key={employee.id} />)}</div>
            <ModalCreateActions message={words && words['WEB.processSuccessMessage']} open={openSuccessMessage} setOpen={setOpenSuccessMessage} />
        </div>
    );
};

export default MyTeams;
